// Matches the stroke weight/color of StreetIcon and UserIconV2 (the sibling
// icons used alongside this one in the Evidence breadcrumb entity fields).
export const TagOutlineIcon = (props) => (
  <svg fill="none" height={18} viewBox="0 0 18 18" width={18} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.3535 2.25H4.5C4.10218 2.25 3.72064 2.40804 3.43934 2.68934C3.15804 2.97064 3 3.35218 3 3.75V7.60649C3 7.99871 3.15774 8.37476 3.43655 8.65083L9.86155 15.0059C10.1518 15.2934 10.5432 15.4547 10.951 15.4547C11.3589 15.4547 11.7502 15.2934 12.0405 15.0059L15.0405 12.0388C15.3305 11.7511 15.4933 11.3607 15.4933 10.9535C15.4933 10.5464 15.3305 10.156 15.0405 9.86825L8.6155 3.51325C8.3364 3.23701 7.96085 3.0743 7.5645 3.05625L8.3535 2.25Z"
      stroke="#A0A5AF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 6.75C6.41421 6.75 6.75 6.41421 6.75 6C6.75 5.58579 6.41421 5.25 6 5.25C5.58579 5.25 5.25 5.58579 5.25 6C5.25 6.41421 5.58579 6.75 6 6.75Z"
      stroke="#A0A5AF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
